(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class StickyAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.bar = document.querySelector('.announcement-bar-section');
      this.announcementIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.barBounds = {};

      this.setBarHeight();

      // 当窗口大小变化时更新高度
      window.addEventListener('resize', this.setBarHeight.bind(this));

      if (this.announcementIsAlwaysSticky) {
        this.bar.classList.add('announcement-bar-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler);

      this.createObserver();
    }

    setBarHeight() {
      document.documentElement.style.setProperty('--announcement-bar-height', `${this.bar.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.setBarHeight);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.barBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.bar);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // ✅ 如果菜单 drawer 打开时，不执行隐藏/显示
      const menuDrawer = document.querySelector('header-drawer details');
      if (menuDrawer && menuDrawer.hasAttribute('open')) return;

      // ✅ 菜单刚关闭后的一小段时间也不触发（防止 scroll 抖动）
      if (window.lastMenuClosed && Date.now() - window.lastMenuClosed < 300) return;

      // 向下滚动并超过横幅高度 → 隐藏
      if (scrollTop > this.currentScrollTop && scrollTop > this.barBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      }
      // 向上滚动并超过横幅高度 → 显示
      else if (scrollTop < this.currentScrollTop && scrollTop > this.barBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      }
      // 到顶部 → 重置
      else if (scrollTop <= this.barBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }


    hide() {
      if (this.announcementIsAlwaysSticky) return;
      this.bar.classList.add('announcement-bar-hidden', 'announcement-bar-sticky');
    }

    reveal() {
      if (this.announcementIsAlwaysSticky) return;
      this.bar.classList.add('announcement-bar-sticky', 'animate');
      this.bar.classList.remove('announcement-bar-hidden');
    }

    reset() {
      if (this.announcementIsAlwaysSticky) return;
      this.bar.classList.remove('announcement-bar-hidden', 'announcement-bar-sticky', 'animate');
    }
  }

  // 注册自定义元素
  customElements.define('sticky-announcement-bar', StickyAnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // ✅ 搜索或菜单打开时，不处理滚动
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      const menuDrawer = document.querySelector('header-drawer details');
      if (menuDrawer && menuDrawer.hasAttribute('open')) return; // ✅ 菜单打开中跳出

      // ✅ 菜单刚关闭后的一段时间也不触发 hide/reveal
      if (this.lastMenuClosed && Date.now() - this.lastMenuClosed < 300) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }



    hide() {
      if (this.headerIsAlwaysSticky) return;
   
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
